export default __webpack_public_path__ + "static/main-23b03fc08948331d688cc7b256e2b5f4.jpeg";